// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;utf8,<svg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 24 24%27 style=%27width: 24px; height: 24px; overflow: visible; fill: white;%27><path d=%27M4.29 12.104c-.277-.308-.75-.332-1.06-.054-.306.278-.33.752-.053 1.06l4.485 4.963c.29.322.795.33 1.096.017L20.414 6.003c.288-.298.28-.773-.02-1.06-.297-.288-.772-.28-1.06.02L8.237 16.47 4.29 12.105z%27></path></svg>", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.divider-10 {
  height: 10px;
  overflow-y: auto;
}

.divider-20 {
  height: 20px;
  overflow-y: auto;
}

.text-description {
  color: rgb(211, 211,211);
  font-size: 11pt !important;
}

.transparent-input:focus {
  background-color: rgba(0, 0, 0, 0) !important;
  color: rgb(255, 255, 255)
}

input[type=checkbox] {
  -webkit-appearance: none;
  box-sizing: border-box;
  position: relative;
  width: 16px;
  height: 16px;
  cursor: pointer;
  outline: none !important;
  border: 2px solid lightgray;
  border-radius: 4px;
  background-color: transparent;
  vertical-align: middle;
  padding: 3px 3px 3px 4px;
  margin-right: 4px;
}

input[type=checkbox]:before {
  content: "\\2713";
  position: absolute;
  top: 50%;
  left: 50%;
  overflow: hidden;
  transform: scale(0) translate(-50%, -50%);
  line-height: 1;
}

input[type=checkbox]:checked {
  background-color: rgb(255, 137, 85, 0.95);
  background-color: rgba(0, 98, 65, 0.98);
  border-color: rgba(255, 255, 255, 0.3);
  border-color: rgba(0, 98, 65, 0.98);
  color: white;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

input[type=checkbox]:checked:before {
  border-radius: 4px;
  transform: scale(1) translate(-50%, -50%);
}

a {
  color: rgba(0, 160, 0, 0.98);
}

a svg {
  color: rgba(0, 160, 0, 0.98) !important;
  font-size: 12px !important;
  vertical-align: super;
}`, "",{"version":3,"sources":["webpack://./src/assets/css/signup.css"],"names":[],"mappings":";AACA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,0BAA0B;AAC5B;;AAEA;EACE,6CAA6C;EAC7C;AACF;;AAEA;EACE,wBAAwB;EAExB,sBAAsB;EACtB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,wBAAwB;EACxB,2BAA2B;EAC3B,kBAAkB;EAClB,6BAA6B;EAC7B,sBAAsB;EACtB,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gBAAgB;EAChB,yCAAyC;EACzC,cAAc;AAChB;;AAEA;EACE,yCAAyC;EACzC,uCAAuC;EACvC,sCAAsC;EACtC,mCAAmC;EACnC,YAAY;EACZ,yDAA8Y;AAChZ;;AAEA;EACE,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,uCAAuC;EACvC,0BAA0B;EAC1B,qBAAqB;AACvB","sourcesContent":["\n.divider-10 {\n  height: 10px;\n  overflow-y: auto;\n}\n\n.divider-20 {\n  height: 20px;\n  overflow-y: auto;\n}\n\n.text-description {\n  color: rgb(211, 211,211);\n  font-size: 11pt !important;\n}\n\n.transparent-input:focus {\n  background-color: rgba(0, 0, 0, 0) !important;\n  color: rgb(255, 255, 255)\n}\n\ninput[type=checkbox] {\n  -webkit-appearance: none;\n  -webkit-box-sizing: border-box;\n  box-sizing: border-box;\n  position: relative;\n  width: 16px;\n  height: 16px;\n  cursor: pointer;\n  outline: none !important;\n  border: 2px solid lightgray;\n  border-radius: 4px;\n  background-color: transparent;\n  vertical-align: middle;\n  padding: 3px 3px 3px 4px;\n  margin-right: 4px;\n}\n\ninput[type=checkbox]:before {\n  content: \"\\2713\";\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  overflow: hidden;\n  transform: scale(0) translate(-50%, -50%);\n  line-height: 1;\n}\n\ninput[type=checkbox]:checked {\n  background-color: rgb(255, 137, 85, 0.95);\n  background-color: rgba(0, 98, 65, 0.98);\n  border-color: rgba(255, 255, 255, 0.3);\n  border-color: rgba(0, 98, 65, 0.98);\n  color: white;\n  background-image: url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' style='width: 24px; height: 24px; overflow: visible; fill: white;'><path d='M4.29 12.104c-.277-.308-.75-.332-1.06-.054-.306.278-.33.752-.053 1.06l4.485 4.963c.29.322.795.33 1.096.017L20.414 6.003c.288-.298.28-.773-.02-1.06-.297-.288-.772-.28-1.06.02L8.237 16.47 4.29 12.105z'></path></svg>\");\n}\n\ninput[type=checkbox]:checked:before {\n  border-radius: 4px;\n  transform: scale(1) translate(-50%, -50%);\n}\n\na {\n  color: rgba(0, 160, 0, 0.98);\n}\n\na svg {\n  color: rgba(0, 160, 0, 0.98) !important;\n  font-size: 12px !important;\n  vertical-align: super;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
